import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      'title': "國際數學日 - 萬人布豐投針實驗企劃"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/slide',
    name: 'Slide',
    meta: {
      'title': "國際數學日 - 萬人布豐投針實驗企劃"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Slide.vue')
  },
  {
    path: '/world',
    name: 'Global',
    meta: {
      'title': "IDM2021 - Buffon's Needle Challenge"
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/World.vue')
  },
  {
    path: '/embedded',
    name: 'Result iframe',
    component: () => import(/* webpackChunkName: "about" */ '../views/Embedded.vue')

  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});

export default router
